/* BDF — HOME AUTOPLAY — canonical runtime controller */
(function(){
  'use strict';

  function parseBool(value){
    return String(value)==='true';
  }

  function syncHeroPrimaryLinks(slideshow){
    if(!document.body.classList.contains('template-index')||!slideshow)return;

    var zones=[
      {key:'clothing',label:'Vêtements',href:'/collections/vetements-bdf',left:'19.4%',width:'13.7%'},
      {key:'personalization',label:'Personnalisation',href:'/pages/tshirt-personnalise-groupe-entrainement',left:'38.2%',width:'20.5%'},
      {key:'accessories',label:'Accessoires',href:'/collections/accessoires-bdf',left:'64.7%',width:'14.5%'}
    ];

    slideshow.querySelectorAll('.slide[data-slider-index="0"]').forEach(function(slide){
      var picture=slide.querySelector('picture');
      if(!picture)return;

      slide.style.position='relative';

      var globalLink=(picture.parentElement&&picture.parentElement.tagName==='A')?picture.parentElement:null;
      if(!globalLink){
        globalLink=document.createElement('a');
        picture.parentNode.insertBefore(globalLink,picture);
        globalLink.appendChild(picture);
      }
      globalLink.classList.add('bdf-home-hero-link');
      globalLink.href='/collections/nouvelle-collection';
      globalLink.setAttribute('aria-label','Découvrir la nouvelle collection');

      slide.querySelectorAll('.bdf-home-hero-hotspot').forEach(function(node){node.remove();});

      zones.forEach(function(zone){
        var hotspot=document.createElement('a');
        hotspot.className='bdf-home-hero-hotspot bdf-home-hero-hotspot--'+zone.key;
        hotspot.href=zone.href;
        hotspot.setAttribute('aria-label',zone.label);
        hotspot.title=zone.label;
        hotspot.style.position='absolute';
        hotspot.style.left=zone.left;
        hotspot.style.top='78%';
        hotspot.style.width=zone.width;
        hotspot.style.height='18%';
        hotspot.style.zIndex='20';
        hotspot.style.display='block';
        hotspot.style.background='transparent';
        hotspot.style.cursor='pointer';
        hotspot.style.textDecoration='none';
        slide.appendChild(hotspot);
      });
    });

    slideshow.dataset.bdfHeroLinksOwner='bdf-home-autoplay';
  }

  function initHeroSlideshowSettings(root){
    if(!document.body.classList.contains('template-index'))return;

    var scope=root&&root.querySelectorAll?root:document;
    var slideshow=(root&&root.matches&&root.matches('.slideshow[data-section-type="slideshow-section"]'))
      ?root
      :scope.querySelector('.slideshow[data-section-type="slideshow-section"]');
    if(!slideshow)return;

    var attempts=0;

    function apply(){
      attempts++;
      if(!window.jQuery||!jQuery.fn||typeof jQuery.fn.slick!=='function'||!slideshow.classList.contains('slick-initialized')){
        if(attempts<30)window.setTimeout(apply,100);
        return;
      }

      var rate=parseInt(slideshow.dataset.sliderHomeRate,10);
      if(!Number.isFinite(rate)||rate<100)rate=7000;

      var autoplay=parseBool(slideshow.dataset.sliderHomeAuto);
      var options={
        autoplay:autoplay,
        autoplaySpeed:rate,
        infinite:parseBool(slideshow.dataset.sliderHomeInfinite),
        dots:parseBool(slideshow.dataset.sliderHomeDots)
      };

      var slider=jQuery(slideshow);
      slider.slick('slickSetOption',options,true);
      if(autoplay)slider.slick('slickPlay');
      else slider.slick('slickPause');
      slideshow.dataset.bdfSlideshowSettingsOwner='bdf-home-autoplay';

      syncHeroPrimaryLinks(slideshow);
      if(!slideshow.dataset.bdfHeroLinksBound){
        slider.on('reInit.bdfHeroLinks setPosition.bdfHeroLinks',function(){
          window.requestAnimationFrame(function(){syncHeroPrimaryLinks(slideshow);});
        });
        slideshow.dataset.bdfHeroLinksBound='true';
      }
    }

    apply();
  }

  function initHomeProductAutoplay(){
    if(!document.body.classList.contains('template-index'))return;

    var section=document.querySelector('.section1');
    if(!section)return;

    var paused=false;
    var timer=null;

    function start(){
      if(timer)return;

      timer=window.setInterval(function(){
        if(paused||document.hidden)return;

        var next=section.querySelector('.slick-next');
        if(next&&next.offsetParent!==null)next.click();
      },2800);
    }

    function stop(){
      if(timer){
        clearInterval(timer);
        timer=null;
      }
    }

    section.addEventListener('mouseenter',function(){paused=true;});
    section.addEventListener('mouseleave',function(){paused=false;});
    section.addEventListener('focusin',function(){paused=true;});
    section.addEventListener('focusout',function(){paused=false;});

    document.addEventListener('visibilitychange',function(){
      if(document.hidden)stop();
      else start();
    });

    start();
  }

  function init(){
    initHeroSlideshowSettings(document);
    initHomeProductAutoplay();
  }

  document.addEventListener('shopify:section:load',function(event){
    initHeroSlideshowSettings(event.target);
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();
